/** 复制文本 */
export async function copyToClipboard(text: string) {
    // 如果支持新的 Clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
    }
    // 如果不支持 Clipboard API，使用 execCommand
    return new Promise<void>((resolve, reject) => {
        try {
            const textarea = document.createElement('textarea');
            textarea.value = text;

            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            textarea.style.opacity = '0';

            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();

            const successful = document.execCommand('copy');
            if (successful) {
                resolve();
            } else {
                reject(new Error('Failed to copy to clipboard'));
            }

            // 清理临时元素
            document.body.removeChild(textarea);
        } catch (err) {
            reject(err);
        }
    });
}
